import React from 'react'
import { IonButton, IonButtons, IonHeader, IonIcon, IonTitle, IonToolbar } from '@ionic/react'
import { add, chevronBackOutline } from 'ionicons/icons'
import { BaseSyntheticEvent } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { setNewPCR, setUpgradeStatus } from '../store/home.actions'
import './HomeHeader.component.css'
import { useHistory } from 'react-router'
import { AppRouterConstants } from '../../../components/appRouter/AppRouter.constants'
import { TabConstants } from '../../../components/tabs/Tabs.constants'
import { IPcrSummary, upgradeStatus } from '../store/home.types'
import { getPCRCrewSelector } from '../../crew/selectors/getPCRCrew.selector'
import { IPCRCrewMemberList } from '../../crew/store/crew.types'
import { createPcr } from '../../pcr/store/pcr.actions'
import { getFormattedTimezone } from '../../../utilities/dateTime.util'
import { getVersion } from '../../../utilities/version.util'
import { getSourceType } from '../../../utilities/platform.util'

const HomeHeader: React.FC = () => {
  const dispatch = useDispatch()
  const history = useHistory()
  const pcrCrewList: IPCRCrewMemberList = useSelector(getPCRCrewSelector)
  const timeZoneOffset: number = new Date().getTimezoneOffset()

  const nextOnClick = (e: BaseSyntheticEvent) => {
    e.preventDefault()
    const data: IPcrSummary = {
      callNature: '',
      patientName: '',
      pickupLocation: '',
      timeZoneOffset: getFormattedTimezone(timeZoneOffset),
      status: 'Incomplete',
      crew: pcrCrewList,
      agencyName: '',
      agencyNumber: {},
      createdBy: '',
      createDateTime: '',
      date: '',
      pcrId: '',
      prid: null,
      serviceId: '',
      time: '',
      unit: '',
      base: '',
      version: getVersion(),
      isChartLockedIn: 0,
      lastAutoUploadDateTime: null,
      signerDetails: [],
      sourceInfo: {
        sourceType: getSourceType(),
      },
    }
    dispatch(setNewPCR(data))
    dispatch(createPcr())
    dispatch(setUpgradeStatus(upgradeStatus.COMPLETE))
    history.push(TabConstants.CHART_ROUTE)
  }

  const onBackClick = (e: BaseSyntheticEvent) => {
    e.preventDefault()
    history.push(AppRouterConstants.CREW_ROUTE)
  }

  return (
    <IonHeader>
      <IonToolbar color='light'>
        <IonButtons slot='start'>
          <IonButton data-testid='Back' onClick={onBackClick} color='primary-alt'>
            <IonIcon icon={chevronBackOutline} />
            Back
          </IonButton>
        </IonButtons>
        <IonButtons slot='end'>
          <IonButton data-testid='CreateChartTablet' className='show-button' onClick={nextOnClick} color='primary-alt'>
            Create Chart
          </IonButton>
          <IonButton data-testid='CreateChartMobile' className='show-icon' onClick={nextOnClick}>
            <IonIcon icon={add} />
          </IonButton>
        </IonButtons>
        <IonTitle>Patient Charts</IonTitle>
      </IonToolbar>
    </IonHeader>
  )
}

export default HomeHeader
